export const ADD_SCHOR_VERTICAL = "ADD_SCHOR_VERTICAL"
export const EDIT_SCHOR_VERTICAL = "EDIT_SCHOR_VERTICAL"
export const LIST_SCHOR_VERTICAL = "LIST_SCHOR_VERTICAL"
export const VIEW_SCHOR_VERTICAL = "VIEW_SCHOR_VERTICAL"
export const DELETE_SCHOR_VERTICAL = "DELETE_SCHOR_VERTICAL"

// Text
export const ADD_SCHOR_VERTICAL_TEXT = "ADD_SCHOR_VERTICAL_TEXT"
export const EDIT_SCHOR_VERTICAL_TEXT = "EDIT_SCHOR_VERTICAL_TEXT"
export const LIST_SCHOR_VERTICAL_TEXT = "LIST_SCHOR_VERTICAL_TEXT"
export const VIEW_SCHOR_VERTICAL_TEXT = "VIEW_SCHOR_VERTICAL_TEXT"
export const DELETE_SCHOR_VERTICAL_TEXT = "DELETE_SCHOR_VERTICAL_TEXT"

export const SCHOR_VERTICAL_SUCCESS = "SCHOR_VERTICAL_SUCCESS"
export const SCHOR_VERTICAL_ERROR = "SCHOR_VERTICAL_ERROR"

